import { useEffect } from 'react';
import { useStore } from 'hooks/useStore';
import { toast } from 'react-toastify';

// Re-export types for backward compatibility
export type {
  StatsData,
  Tag,
  InfoCardData,
  SearchSuggestion,
  LandingPageData,
} from 'Interfaces/ProductWikiInterfaces';

export const useLandingPageLogic = () => {
  const {
    LandingPageStore: {
      landingPageData,
      isLandingPageLoading,
      fetchLandingPageData,
      resetDropdownValues,
      fetchContractExpirations,
      fetchAndaUpdates,
      fetchLossOfExclusivity,
      fetchPreSolicitationAlerts,
    },
  } = useStore();

  useEffect(() => {
    // Reset dropdown values to defaults when component mounts/navigates back
    resetDropdownValues();

    // Fetch landing page data from API
    const loadData = async () => {
      try {
        await fetchLandingPageData();

        // Refetch sections with default values to ensure data matches dropdown selection
        // This ensures that if sections were previously fetched with custom values,
        // they are refetched with defaults after reset
        await Promise.all([
          fetchContractExpirations(90), // Default: 3 months
          fetchAndaUpdates(90), // Default: 3 months
          fetchLossOfExclusivity(90), // Default: 3 months
          fetchPreSolicitationAlerts('duedate'), // Default: duedates
        ]);
      } catch (_error) {
        toast.error('Error fetching landing page data. Please try again.');
      }
    };

    loadData();
  }, [
    fetchLandingPageData,
    resetDropdownValues,
    fetchContractExpirations,
    fetchAndaUpdates,
    fetchLossOfExclusivity,
    fetchPreSolicitationAlerts,
  ]);

  return {
    landingPageData,
    loading: isLandingPageLoading,
  };
};
